import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { GameLogic } from "../../../Logic/GameLogic";
import { GameModel } from "../../../Models/GameModel";
import { scaleModal } from "../../../Utils/DialogScale";
import { TextInput } from "../../../Utils/TextInput";
import { AnimationContents } from "../../AnimationContents";
import { ButtonController, IButtonControllerOptions } from "../../Common/ButtonController";

export interface IEnterNameScreenControllerOptions {

}

export class EnterNameScreenController extends AnimationBaseController {
    $model: GameModel;
    nameValue: string;
    private _width: number = 0;
    private _height: number = 0;
    public constructor(
        @Inject private _options: IEnterNameScreenControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super('EnterNameScreenController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.ENTER_NAME_JSON,
            libraryName: "enter_your_name_screen",
            childControllers: {
                ButtonConfirm: {
                    instanceName: "btn_confirm",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.$model.player.name = this.nameValue;
                            //this._gameLogic.startNewGame();
                            this._gameLogic.hideModal();
                            this._gameLogic.showChoosePerson();
                            //this._gameLogic.showTapToStart();
                        }
                    }
                }

            },
            modelWatch: {

            }
        };
    }

    protected onInitialize() {
        this._width = 1047;
        this._height = 606;
        const width = 544;
        const input = new TextInput('', {
            input: {
                fontSize: '25pt',
                padding: '14px',
                width: `${width}px`,
                fontFamily: 'Myriad Pro',
                background: 'none',
                color: '#ffffff',
            },
            box: null,
        });



        input.x = -290;
        input.y = -104;
        input.text = this.$model.player.name;
        this.nameValue = input.text;
        if (this.nameValue === '') {
            const btnConfirm = this.$childControllers.get<ButtonController>('ButtonConfirm');
            btnConfirm.disabled();

            input.on('input', value => {
                if (value.length > 50) {
                    input.text = <string>(input.text).substring(0, 50);
                }
                this.nameValue = input.text;
                if (input.text === '') {
                    btnConfirm.disabled()
                } else {
                    btnConfirm.enabled();
                }
            });
        } else {
            input.disabled = true;
        }
        // @ts-ignore
        this.display.addChild(input);
    }
    onResize(width: number, height: number, scale: number) {
        scaleModal(this, width, height, scale * 1.3, this._width, this._height);
    }
}